import React from 'react';
// B-Design only applies style to Range component.
import Slider from 'antd/es/slider';
import AntdConfigProvider from 'antd/es/config-provider';
import { ConfigContext } from '../config-provider';
// export default withConfigProvider(Slider);
const BdSlider = React.forwardRef((props, ref) => {
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', props.prefixCls), ...restContext },
        React.createElement(Slider, { ...props, ref: ref })));
});
export default BdSlider;
